import { render, staticRenderFns } from "./BoardAgileCompletedSprint.vue?vue&type=template&id=978ae44e&"
import script from "./BoardAgileCompletedSprint.vue?vue&type=script&lang=js&"
export * from "./BoardAgileCompletedSprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports